import React, { ReactNode, useEffect, useRef } from 'react'

import Flicking from '@egjs/react-flicking'

const getPanelsKeys = (_children: ReactNode): string => {
  if (!Array.isArray(_children)) {
    if (!React.isValidElement(_children)) return 'invalid'
    return _children.key?.toString() ?? 'invalid'
  }
  return _children.reduce<string>((prev, c) => {
    if (Array.isArray(c)) return prev.concat(getPanelsKeys(c))

    if (!React.isValidElement(c)) return prev.concat('invalid')
    return prev.concat(c.key?.toString() ?? 'invalid')
  }, '')
}

const useReInitializeOnNonStrict = (
  flickingRef: React.RefObject<Flicking>,
  children?: ReactNode,
  useReinitialize?: boolean,
) => {
  const panelKeys = useRef<{ value: string }>({ value: '' })

  useEffect(() => {
    if (useReinitialize) {
      const nextPanelsKeys = getPanelsKeys(children)
      if (panelKeys.current.value !== nextPanelsKeys && flickingRef.current?.initialized) {
        flickingRef.current?.destroy()
        flickingRef.current?.init()
      }
      panelKeys.current.value = nextPanelsKeys
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children])
}
export default useReInitializeOnNonStrict
